/**
 * This is for base url only. Not to be used my applicaiton, only loading and bootstrapping app
 */
export class ConfigData {
    baseUrl: string = '/';

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }
}